<template>
  <div
    class="bg-FFFFFF fb fb-cross-center fb-main-between"
    :class="{ 'pl-16': showPadding }"
  >
    <div
      class="w-36 h-36 bd-p-50 hidden c-FFFFFF font-28 fb fb-cross-center fb-main-center"
    >
      <img
        v-if="+studentInfo.gender === 1"
        :key="studentInfo.gender"
        src="@/assets/images/avator1-1.png"
      />
      <img
        :key="studentInfo.gender"
        v-else-if="+studentInfo.gender === 2"
        src="@/assets/images/avator2-1.png"
      />
      <img v-else src="@/assets/images/avator0-1.png" />
    </div>

    <div
      class="item-flex-1 ml-12 pr-16 p-10-0 bg-FFFFFF fb fb-cross-center fb-main-between"
      :class="{ bb: showLine }"
    >
      <div class="item-flex-1">
        <div class="fb fb-row fb-cross-center">
          <span
            class="inline-block font-34 lh-24 mr-4"
            :class="[!showAllClass && 'max-w-100 text-ellipsis ']"
            :style="{ 'max-width': maxWidth }"
            >{{ filterName(studentInfo.name, 10) }}</span
          >
          <span
            class="iconfont font-32"
            :style="{
              color: +studentInfo.gender === 1 ? '#006AFE' : '#ff4d94'
            }"
            v-show="studentInfo.gender"
            v-html="SEX_TYPE_ICON[+studentInfo.gender]"
          ></span>
        </div>
        <div
          class="c-171A1D-56 font-28"
          :class="[showAllClass ? 'ellipsis-l2' : 'max-w-100 text-ellipsis ']"
          :style="{ 'max-width': maxWidth }"
          >{{ filterName(studentInfo.className, 16) }}</div
        >
        <div
          v-show="studentInfo.tagName || studentInfo.dormName"
          class="fb fb-row fb-cross-center fb-main-start pt-5"
        >
          <span
            class="inline-block h-22 lh-22 p-0-10 bg-006AFE-8 font-24 c-006AFE bd-radio-9999 mr-8 nowrap"
            v-show="studentInfo.tagName"
            >{{ studentInfo.tagName }}</span
          >
          <span
            class="inline-block h-22 lh-22 p-0-10 bg-006AFE-8 font-24 c-006AFE bd-radio-9999 max-w-220 text-ellipsis"
            v-show="studentInfo.dormName"
            >{{ studentInfo.dormName }}</span
          >
        </div>
        <slot></slot>
      </div>
      <span v-show="showArrow" class="iconfont font-32 c-171A1D-40"
        >&#xe66b;</span
      >
    </div>
  </div>
</template>

<script>
import { SEX_TYPE_ICON } from '@/utils/constUtils'
import { filterName } from '@/utils/comUtils'
export default {
  name: 'commonStudentSimple',
  components: {},
  props: {
    showArrow: {
      type: Boolean,
      default: false
    },
    showAllClass: {
      type: Boolean,
      default: false
    },
    showPadding: {
      type: Boolean,
      default: false
    },
    showLine: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: '100px'
    },
    studentInfo: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          gender: 0,
          className: '',
          tagName: '',
          dormName: ''
        }
      }
    }
  },
  data() {
    return {
      filterName,
      SEX_TYPE_ICON
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
